// extracted by mini-css-extract-plugin
export default {"header":"styles_header__RqfWQ","header_page_wrapper":"styles_header_page_wrapper__0qPrG"};